import { render, staticRenderFns } from "./Typography4.vue?vue&type=template&id=6e23a17a&scoped=true"
import script from "./Typography4.vue?vue&type=script&lang=js"
export * from "./Typography4.vue?vue&type=script&lang=js"
import style0 from "./Typography4.vue?vue&type=style&index=0&id=6e23a17a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e23a17a",
  null
  
)

export default component.exports